import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../components/common/Button';
import { FaExclamationTriangle, FaHome } from 'react-icons/fa';

const NotFoundContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 60vh;
  padding: 80px 20px;
`;

const NotFoundIcon = styled.div`
  font-size: 5rem;
  color: ${props => props.theme.colors.primaryColor};
  margin-bottom: 20px;
`;

const NotFoundCode = styled.h1`
  font-size: 6rem;
  color: ${props => props.theme.colors.secondaryColor};
  margin-bottom: 20px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: 4rem;
  }
`;

const NotFoundTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.xxlarge};
  margin-bottom: 20px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
`;

const NotFoundText = styled.p`
  font-size: ${props => props.theme.fontSizes.medium};
  color: ${props => props.theme.colors.grey[600]};
  max-width: 600px;
  margin-bottom: 40px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.regular};
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 20px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
  }
`;

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | KALS Academy</title>
        <meta name="description" content="The page you are looking for could not be found." />
      </Helmet>
      
      <NotFoundContainer>
        <NotFoundIcon>
          <FaExclamationTriangle />
        </NotFoundIcon>
        <NotFoundCode>404</NotFoundCode>
        <NotFoundTitle>Page Not Found</NotFoundTitle>
        <NotFoundText>
          We're sorry, the page you are looking for does not exist or has been moved.
          Please check the URL or go back to the homepage.
        </NotFoundText>
        
        <ButtonsContainer>
          <Button to="/" variant="primary">
            <FaHome style={{ marginRight: '8px' }} />
            Back to Home
          </Button>
          <Button to="/contact" variant="secondary">
            Contact Us
          </Button>
        </ButtonsContainer>
      </NotFoundContainer>
    </>
  );
};

export default NotFoundPage;
